/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sorry-message[_ngcontent-%COMP%] {\n  padding: 20px;\n  background: lightcyan;\n  color: black;\n  font-size: 15px;\n  border: 1px solid cornflowerblue; }\n\n@media (min-width: 640px) and (min-width: 768px) {\n  .body[_ngcontent-%COMP%], address[_ngcontent-%COMP%], dl[_ngcontent-%COMP%], p[_ngcontent-%COMP%], ul[_ngcontent-%COMP%] {\n    font-size: 1.5rem;\n    font-weight: normal; } }"];
export { styles as styles };
